






































import { defineComponent } from "@vue/composition-api"
import { useGetters, useMutations, useState } from "vuex-composition-helpers"

import ContentComponent from "../shared/ContentComponent.vue"
import CrumbsComponent from "../shared/CrumbsComponent.vue"
import ImageComponent from "../shared/ImageComponent.vue"
import IntroComponent from "../shared/IntroComponent.vue"
import NavigationComponent from "../shared/NavigationComponent.vue"
import VideoComponent from "../shared/VideoComponent.vue"

export default defineComponent({
    name: "IntroSlider",
    components: {
        ContentComponent,
        CrumbsComponent,
        ImageComponent,
        IntroComponent,
        NavigationComponent,
        VideoComponent
    },
    setup: () => {
        const { showContent, transition, videoIsPlaying } = useState(['showContent', 'transition', 'videoIsPlaying'])
        const { singleSlide, shouldShowLink, shouldShowContent, assetComponent, assetContent } = useGetters(['singleSlide', 'shouldShowLink', 'shouldShowContent', 'assetComponent', 'assetContent'])
        const { toggleContent } = useMutations(['toggleContent'])

        return {
            assetComponent,
            assetContent,
            showContent,
            singleSlide,
            shouldShowLink,
            shouldShowContent,
            toggleContent,
            transition,
            videoIsPlaying
        }
    }
})
